module.exports = __webpack_public_path__ + "img/serviceTakeback-step1@2x.b99426a4.png";